import apiClient from './client';

export interface EffectiveCell {
  jobId: number;
  jobTitle: string;
  source: 'home' | 'override';
  scheduleId?: number;
}

export interface EffectiveEmployee {
  user_id: number;
  employee_id: number;
  name: string;
  homeJobId: number | null;
  homeJobTitle: string | null;
  cells: Record<string, EffectiveCell | null>;
  /** Approved time-off days in the window (CR #106) */
  timeOff?: Record<string, boolean>;
}

export interface JobOption { id: number; title: string; job_number: string }

export interface EffectiveSchedule {
  days: string[];
  employees: EffectiveEmployee[];
  jobs: JobOption[];
}

export const getEffectiveSchedule = async (startDate: string, endDate: string): Promise<EffectiveSchedule> => {
  const r = await apiClient.get('/schedule/effective', { params: { startDate, endDate } });
  return r.data.data;
};

export const setHomeJob = async (user_id: number, job_id: number | null): Promise<void> => {
  await apiClient.put('/schedule/home-job', { user_id, job_id });
};

export const createOverride = async (payload: {
  user_id: number; job_id: number; date: string; end_date?: string; start_time?: string; end_time?: string;
}): Promise<void> => {
  await apiClient.post('/schedule/override', payload);
};

export const deleteOverride = async (scheduleId: number, userId: number): Promise<void> => {
  await apiClient.delete(`/schedule/override/${scheduleId}/${userId}`);
};
